export default "__VITE_ASSET__CnWNS8WL__"